import React, { Component } from "react";
import moment from "moment";
import Utils from "@/utils";
import ToGIFWorkContentVideoRender from "./children/ToGIFWorkContentVideoRender";

import "@/assets/toGIF.less";

class ToGIFWorkFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoReady: false,
      playing: false,
      pauseBtnVisible: false,
      currentTime: "00:00:00",
      currentTimePercent: 0,
    };
  }

  getVideoSize = () => {
    const Preview = document.querySelector(".videoWrap");
    const video = document.querySelector(".videoWrap video");
    video.load();
    if (!video.handleLoadEvent) {
      video.handleLoadEvent = e => {
        const videoWidth = e.target.videoWidth;
        const videoHeight = e.target.videoHeight;
        if (videoHeight > Preview.clientHeight) {
          video.style.width = "auto";
          video.style.height = Preview.clientHeight + "px";
        } else {
          if (videoHeight > videoWidth) {
            video.style.width = "auto";
            video.style.height = "100%";
          } else {
            video.style.width = "100%";
            video.style.height = "auto";
            video.style.maxHeight = Preview.clientHeight + "px";
          }
        }
        this.setState({ videoReady: true });
        const toGifObj = { ...this.props.toGifObj };
        toGifObj.width = e.target.videoWidth;
        toGifObj.height = "AUTO";
        this.props.onToGifObjChange(toGifObj);
      };
      video.addEventListener("loadeddata", video.handleLoadEvent);
    }
  };

  _getCurrentTime = () => {
    if (!this.state.playing) {
      return false;
    }
    const myvideo = document.querySelector("#videoRef video");
    this.setState({
      currentTime: moment("00:00:00", "mm:ss:SS")
        .add(myvideo.currentTime, "seconds")
        .format("mm:ss:SS")
        .replace(/:([^:]*)$/, ".$1"),
      currentTimePercent: (myvideo.currentTime / myvideo.duration) * 100,
    });
    let endTime = Utils.getSeconds(this.props.toGifObj.end);
    if (endTime > myvideo.duration) {
      endTime = myvideo.duration;
    }
    if (myvideo.currentTime < endTime) {
      window.requestAnimationFrame(this._getCurrentTime);
    } else {
      if (this.props.toGifObj) {
        // 播放结束停留在选框开始位置
        this.setState({
          playing: false,
          currentTimePercent: this.getCutPercent(this.props.toGifObj.start),
          currentTime: moment(this.props.toGifObj.start.replace(".", ":"), "mm:ss:SS")
            .format("mm:ss:SS")
            .replace(/:([^:]*)$/, ".$1"),
          pauseBtnVisible: false,
        });
        myvideo.currentTime = Utils.getSeconds(this.props.toGifObj.start);
        myvideo.pause();
      } else {
        this.setState({
          playing: false,
          pauseBtnVisible: false,
          currentTimePercent: 0,
          currentTime: "00:00:00",
        });
        myvideo.currentTime = 0;
      }
    }
  };

  handleVideoPlay = () => {
    this.setState({ playing: !this.state.playing });
    const myvideo = document.querySelector("#videoRef video");
    if (this.state.playing) {
      myvideo.pause();
      this.setState({ pauseBtnVisible: false });
    } else {
      // 保证指针在选框范围内
      if (myvideo.currentTime < Utils.getSeconds(this.props.toGifObj.start) || myvideo.currentTime >= Utils.getSeconds(this.props.toGifObj.end)) {
        myvideo.currentTime = Utils.getSeconds(this.props.toGifObj.start);
      }
      this.setState({ pauseBtnVisible: true });
      myvideo.play();
      window.requestAnimationFrame(this._getCurrentTime);
    }
  };

  handleCurrentTimeChange = value => {
    const myvideo = document.querySelector("#videoRef video");
    myvideo.currentTime = myvideo.duration * (value / 100);
    this.setState({
      currentTime: moment("00:00:00", "mm:ss:SS")
        .add(myvideo.currentTime, "seconds")
        .format("mm:ss:SS")
        .replace(/:([^:]*)$/, ".$1"),
      currentTimePercent: value,
    });
  };

  handlePauseBtnShow = e => {
    if (this.state.playing) {
      this.setState({ pauseBtnVisible: true });
    }
  };

  getCutPercent = value => {
    const d = Utils.getSeconds(this.props.toGifObj.duration);
    const t = Utils.getSeconds(value);
    return (t / d) * 100;
  };

  handleRangeChange = value => {
    if (this.state.playing) {
      this.handleVideoPlay();
    }
    const d = Utils.getSeconds(this.props.toGifObj.duration);
    if ((d * value[1]) / 100 - (d * value[0]) / 100 <= 1) {
      this.setState({ miniLengthLimit: true });
      return false;
    }
    if ((d * value[1]) / 100 - (d * value[0]) / 100 > 51) {
      this.setState({ maxLengthLimit: true });
      return false;
    }
    this.setState({ miniLengthLimit: false });
    this.setState({ maxLengthLimit: false });
    const start = moment("00:00:00", "mm:ss:SS")
      .add((d * value[0]) / 100, "seconds")
      .format("mm:ss:SS")
      .replace(/:([^:]*)$/, ".$1");
    const end = moment("00:00:00", "mm:ss:SS")
      .add((d * value[1]) / 100, "seconds")
      .format("mm:ss:SS")
      .replace(/:([^:]*)$/, ".$1");
    let toGifObj = { ...this.props.toGifObj };
    toGifObj.start = start;
    toGifObj.end = end;
    this.props.onToGifObjChange(toGifObj);
  };

  componentDidMount() {
    if (this.props.toGifObj) {
      this.getVideoSize();
    }
  }

  render() {
    return (
      <ToGIFWorkContentVideoRender
        toGifObj={this.props.toGifObj}
        videoReady={this.state.videoReady}
        playing={this.state.playing}
        currentTimePercent={this.state.currentTimePercent}
        pauseBtnVisible={this.state.pauseBtnVisible}
        miniLengthLimit={this.state.miniLengthLimit}
        maxLengthLimit={this.state.maxLengthLimit}
        handleVideoPlay={this.handleVideoPlay}
        handlePauseBtnShow={this.handlePauseBtnShow}
        handlePauseBtnHide={() => this.setState({ pauseBtnVisible: false })}
        handleCurrentTimeChange={this.handleCurrentTimeChange}
        getCutPercent={this.getCutPercent}
        handleRangeChange={this.handleRangeChange}
      />
    );
  }
}

export default ToGIFWorkFunction;
